import $ from 'jquery'
import { autocomplete, getAlgoliaResults } from '@algolia/autocomplete-js';
import algoliasearch from 'algoliasearch/lite'
import instantsearch from 'instantsearch.js'
import {
  configure,
  menu,
  refinementList,
  clearRefinements,
} from 'instantsearch.js/es/widgets'
import { connectSearchBox } from 'instantsearch.js/es/connectors'
import { connectStats } from 'instantsearch.js/es/connectors';
import { connectInfiniteHits } from 'instantsearch.js/es/connectors'
import { history } from 'instantsearch.js/es/lib/routers'
import { placeHit, placeButton } from '../components/placeHit'
import infiniteHits from '../components/infiniteHits'
import searchBox from '../components/searchBox'
import { algoliaAppId, algoliaApiKey, locationSearchIndex, placeSearchIndex, placeSearchSuggestionsIndex } from '../variables'
import { lockBody, unlockBody } from '../utils'
import {Alert, dynamicUriTemplate, extractParamsFromUri} from '../functions'
import {createCookie, readCookie} from '../global'
import showMoreText from '../components/showMoreText'
import '@algolia/autocomplete-theme-classic';
import {headerSearch, sharedSearchBox} from "../headers/navbar";

// eslint-disable-next-line no-undef
const { __ } = wp.i18n

// eslint-disable-next-line no-undef
const object = vnObject

// Get slugs from theme options to rewrite slugs in french
const {
  mainSlug,
  query,
  placeCategory,
  placeSuitableFor,
  placeType,
  location_filter,
} = object.placesQueryStrings

const slugs = {
  query,
  placeCategory,
  placeSuitableFor,
  placeType,
  location_filter,
}

// Variables to rewrite slugs with custom parameters
var currentLocation = '';

// Build places page
let placesSearch
let placesLocationsSearch
let modalPlacesLocationsSearch
const checkEl = document.querySelector('.pt-places__posts')
if (checkEl) {
  const searchClient = algoliasearch(algoliaAppId, algoliaApiKey)

  placesSearch = instantsearch({
    future: {
      preserveSharedStateOnUnmount: true,
    },
    indexName: placeSearchIndex,
    indexId: placeSearchIndex,
    searchClient,
    insights: true,
    clickAnalytics: true,
    routing: {
      // Rewrite and create slugs with our options
      router: history({
        cleanUrlOnDispose: false,
        createURL({ location, routeState  }) {
          if (headerSearch != undefined ) {
            headerSearch.helper.setQueryParameter('query', routeState.query).search();
          }
          const params = {
            query: routeState.query,
            location_filter: currentLocation,
            placeCategory: routeState.placeCategory,
            placeSuitableFor: routeState.placeSuitableFor,
            placeType: routeState.placeType,
          }

          return dynamicUriTemplate(location.origin, params, mainSlug, slugs)
        },

        parseURL({ location }) {
          const params = extractParamsFromUri(location.href, slugs)

          return {
            query: params[slugs.query] && params[slugs.query][0],
            location_filter: params[slugs.location_filter],
            placeCategory: params[slugs.placeCategory],
            placeSuitableFor: params[slugs.placeSuitableFor],
            placeType: params[slugs.placeType],
          }
        },
      }),

      // Rewrite and create slugs with our options
      stateMapping: {
        stateToRoute(uiState) {
          const indexUiState = uiState[placeSearchIndex] || {}

          const res = {
            query: indexUiState.query,
            location_filter: currentLocation,
            placeType: indexUiState.refinementList?.['placeType.name'],
            placeSuitableFor: indexUiState.refinementList?.['placeSuitableFor.name'],
            placeCategory: indexUiState.menu?.['placeCategory.slug'],
          }

          return res
        },

        routeToState(routeState) {
          currentLocation = routeState.location_filter

          var placeCategory = ''
          if ( routeState.placeCategory != undefined ) {
            placeCategory = routeState.placeCategory[0]
          }

          return {
            [placeSearchIndex]: {
              query: routeState.query,
              location_filter: routeState.location_filter,
              menu: {
                'placeCategory.slug': placeCategory,
              },
              refinementList: {
                'placeSuitableFor.name': routeState.placeSuitableFor,
                'placeType.name': routeState.placeType,
              },
            },
          }
        },
      },
    },
  })

  const customSearchBox = connectSearchBox(searchBox)
  const customInfiniteHits = connectInfiniteHits(
      infiniteHits(placeHit, placeButton)
  )

  const renderStats = (renderOptions, isFirstRender) => {
    const { nbHits } = renderOptions;

    document.querySelectorAll('.js-places-stat').forEach(element => {
      element.innerHTML = `
        <p>${nbHits} ${__('results displayed', 'vn')}</p>
      `;
    });
  };

  const customStats = connectStats(
      renderStats
  );

  placesSearch.addWidgets([
    customSearchBox({
      container: '.site-header-handler',
      placeholder: __('Search ...', 'vn'),
      showLoadingIndicator: false,
    }),

    // Init counter
    customStats({
    }),

    // Init place category checkboxes
    menu({
      container: '.place-category-handler',
      attribute: 'placeCategory.slug',
      templates: {
        item(data, { html }) {
          const { label, count, url, cssClasses } = data;
          if ( label == __( 'All', 'vn' ) || label == 'Tous' ) {
            return html`
              <a class="${cssClasses.link}" href="${url}" data-placeholder="${__( 'Search ...', 'vn' )}" data-mobile-text="${__( 'Search ...', 'vn' )}">
                <img src="${object.allIcon}" alt="${__( 'All', 'vn' )}"></img>
                <span class="${cssClasses.label}">${__( 'All', 'vn' )}</span>
              </a>
            `;
          }
          var term = object.placesCategories[label]
          if ( term ) {
            return html`
              <a class="${cssClasses.link}" href="${url}" data-placeholder="${term['selected_text']}" data-mobile-text="${term['mobile_selected_text']}">
                <img src="${term['icon']}" alt="${term['name']}"></img>
                <span class="${cssClasses.label}">${term['name']}</span>
              </a>
            `;
          }

          return html`
            <a class="${cssClasses.link}" href="${url}">
              <span class="${cssClasses.label}">${label}</span>
            </a>
          `;
        },
      },
    }),

    // Init place suitable for checkboxes
    refinementList({
      container: '.place-suitable-for-handler',
      attribute: 'placeSuitableFor.name',
      sortBy: ['name'],
      limit: 999,
      templates: {
        showMoreText(data) {
          return showMoreText(data)
        },
        /*item(data, { html }) {
          const { url, label, count, isRefined } = data;
          var term = object.placesSuitableFor[label]
          if ( term ) {
            return html`
              <label class="ais-RefinementList-label">
                <input type="checkbox" class="ais-RefinementList-checkbox" value="${label}"></input>
                <span class="ais-RefinementList-labelText">
                  ${term['name']}
                </span>
              </label>
            `;
          }

          return html`
            <label class="ais-RefinementList-label">
              <input type="checkbox" class="ais-RefinementList-checkbox" value="${label}"></input>
              <span class="ais-RefinementList-labelText">
                ${label}
              </span>
            </label>
          `;
        },*/
      },
    }),

    // Init business sector checkboxes
    refinementList({
      container: '.place-type-handler',
      attribute: 'placeType.name',
      sortBy: ['name'],
      limit: 999,
      templates: {
        showMoreText(data) {
          return showMoreText(data)
        },
        /*item(data, { html }) {
          const { url, label, count, isRefined } = data;
          var term = object.placeTypes[label]
          if ( term ) {
            return html`
              <label class="ais-RefinementList-label">
                <input type="checkbox" class="ais-RefinementList-checkbox" value="${label}"></input>
                <span class="ais-RefinementList-labelText">
                  ${term['name']}
                </span>
              </label>
            `;
          }

          return html`
            <label class="ais-RefinementList-label">
              <input type="checkbox" class="ais-RefinementList-checkbox" value="${label}"></input>
              <span class="ais-RefinementList-labelText">
                ${label}
              </span>
            </label>
          `;
        },*/
      },
    }),

    // Set places feed container
    customInfiniteHits({
      container: document.querySelector('.places-hits-handler'),
    }),

    // Set number of places per page
    configure({
      hitsPerPage: 52,
    }),


    clearRefinements({
      container: '.js-places-clear',
      templates: {
        resetLabel({ hasRefinements }, { html }) {
          return html`<span
            >${hasRefinements
              ? __('Remove filters', 'vn')
              : __('No filters', 'vn')}</span
          >`
        },
      },
    }),
    clearRefinements({
      container: '.js-places-modal-clear',
      templates: {
        resetLabel({ hasRefinements }, { html }) {
          return html`<span
            >${hasRefinements
              ? __('Remove filters', 'vn')
              : __('No filters', 'vn')}</span
          >`
        },
      },
    }),
  ])

  placesSearch.start()


  // Init location autocomplete input
  placesLocationsSearch = autocomplete({
    container: '.places-location-handler',
    detachedMediaQuery: 'none',
    placeholder: __('Your location...', 'vn'),
    // On input reset, remove aroundLatLng parameter from query
    onReset() {
      placesSearch.helper.setQueryParameter('aroundLatLng', '').search();
      placesSearch.helper.setQueryParameter('insidePolygon', '').search();
    },
    // On input change, remove aroundLatLng parameter from query
    onStateChange({ prevState, state }) {
      if (state.query != undefined && state.query.length == 0) {
        placesSearch.helper.setQueryParameter('aroundLatLng', '').search();
        placesSearch.helper.setQueryParameter('insidePolygon', '').search();
        currentLocation = '';
      }
    },
    getSources() {
      return [
        {
          // Set source of the autocomplete datas
          sourceId: 'myLocation',
          getItems({ query }) {
            var cookieLatLng = readCookie('lat_lng')

            var latitude = null;
            var longitude = null;

            if ( cookieLatLng != null ) {
              var parts = cookieLatLng.split(',');

              latitude = parseFloat(parts[0]);
              longitude = parseFloat(parts[1]);
            }
            return [
              { title: __('Near', 'vn'), lat: latitude, lng: longitude },
            ]
          },
          // Set template of the autocomplete datas
          templates: {
            item({ item }) {
              return `${item.title}`;
            },
          },
          // On select, change the value of current location
          onSelect: function (event) {
            var latitude = event.item.lat;
            var longitude = event.item.lng;

            if ( latitude == null || event.item.lng == null ) {
              navigator.geolocation.getCurrentPosition(
                  function(position) {
                    latitude = position.coords.latitude;
                    longitude = position.coords.longitude;

                    createCookie('lat_lng', latitude + ', ' + longitude, '10');

                    event.setQuery(event.item.title);
                    placesLocationsSearch.setQuery(event.item.title);
                    modalPlacesLocationsSearch.setQuery(event.item.title);
                    let latLng = parseFloat(latitude) + ',' + parseFloat(longitude);
                    currentLocation = event.item.title;

                    placesSearch.helper.setQueryParameter('insidePolygon', '').search();
                    placesSearch.helper.setQueryParameter('aroundLatLng', latLng).search();

                    var radiusInMeter = object.defaultRadius * 1000;
                    placesSearch.helper.setQueryParameter('aroundRadius', radiusInMeter).search();
                  },
                  function(error) {
                    Alert('warning', __('Geolocation is disabled. Please enable it in your browser settings.'), false)
                  }
              );
            }
            else {
              event.setQuery(event.item.title);
              placesLocationsSearch.setQuery(event.item.title);
              modalPlacesLocationsSearch.setQuery(event.item.title);
              let latLng = parseFloat(latitude) + ',' + parseFloat(longitude);
              currentLocation = event.item.title;

              placesSearch.helper.setQueryParameter('insidePolygon', '').search();
              placesSearch.helper.setQueryParameter('aroundLatLng', latLng).search();

              var radiusInMeter = object.defaultRadius * 1000;
              placesSearch.helper.setQueryParameter('aroundRadius', radiusInMeter).search();
            }
          },
        },
        {
          // Set source of the autocomplete datas
          sourceId: 'locationsPlaces',
          getItems({ query }) {
            return getAlgoliaResults({
              searchClient,
              queries: [
                {
                  indexName: locationSearchIndex,
                  query,
                },
              ],
            })
          },
          // Set template of the autocomplete datas
          templates: {
            item({ item }) {
              return `${item.title}`;
            },
          },
          // On select, change the value of current location
          onSelect: function (event) {
            event.setQuery(event.item.title);
            placesLocationsSearch.setQuery(event.item.title);
            modalPlacesLocationsSearch.setQuery(event.item.title);
            let placesInfo = object.placesAlgoliaValues
            currentLocation = event.item.title;

            let currentPlaceInfos = placesInfo[currentLocation]

            placesSearch.helper.setQueryParameter('aroundLatLng', '');
            placesSearch.helper.setQueryParameter('insidePolygon', '');
            placesSearch.helper.setQueryParameter(currentPlaceInfos.algolia_query, currentPlaceInfos.algolia_value).search();

            var radiusInMeter = object.defaultRadius * 1000;
            placesSearch.helper.setQueryParameter('aroundRadius', radiusInMeter).search();
          },
        }
      ];
    },
  });

  // Init location autocomplete input IN MODAL
  modalPlacesLocationsSearch = autocomplete({
    container: '.modal-places-location-handler',
    detachedMediaQuery: 'none',
    placeholder: __('Your location...', 'vn'),
    // On input reset, remove aroundLatLng parameter from query
    onReset() {
      placesSearch.helper.setQueryParameter('aroundLatLng', '').search();
      placesSearch.helper.setQueryParameter('insidePolygon', '').search();
    },
    // On input change, remove aroundLatLng parameter from query
    onStateChange({ prevState, state }) {
      if ( state.query != undefined && state.query.length == 0 ) {
        placesSearch.helper.setQueryParameter('aroundLatLng', '').search();
        placesSearch.helper.setQueryParameter('insidePolygon', '').search();
        $('.js-where-result').html('')
        currentLocation = ''
      }
    },
    getSources() {
      return [{
        // Set source of the autocomplete datas
        sourceId: 'locationsPlaces',
        getItems({ query }) {
          return getAlgoliaResults({
            searchClient,
            queries: [
              {
                indexName: locationSearchIndex,
                query,
              },
            ],
          });
        },
        // Set template of the autocomplete datas
        templates: {
          item({ item }) {
            return `${item.title}`;
          },
        },
        // On select, change the value of current location
        onSelect: function (event) {
          event.setQuery( event.item.title );
          placesLocationsSearch.setQuery( event.item.title );
          modalPlacesLocationsSearch.setQuery( event.item.title );
          let placesInfo = object.placesAlgoliaValues
          currentLocation = event.item.title;

          let currentPlaceInfos = placesInfo[currentLocation]
          placesSearch.helper.setQueryParameter('aroundLatLng', '');
          placesSearch.helper.setQueryParameter('insidePolygon', '');
          placesSearch.helper.setQueryParameter(currentPlaceInfos.algolia_query, currentPlaceInfos.algolia_value).search();

          var radiusInMeter = object.defaultRadius * 1000
          placesSearch.helper.setQueryParameter('aroundRadius', radiusInMeter).search();
        },
      }];
    },
  });

  // Change the algolia query for the geo spacing request if current location is filled
  var cookieLatLng = readCookie('lat_lng')
  if ( currentLocation || cookieLatLng != null ) {
    if ( currentLocation == __( 'Near', 'vn') || ( ! currentLocation && cookieLatLng != null ) ) {

      if ( cookieLatLng != null ) {
        var parts = cookieLatLng.split(',');

        var latitude = parseFloat(parts[0]);
        var longitude = parseFloat(parts[1]);

        placesSearch.helper.setQueryParameter('insidePolygon', '');

        var radiusInMeter = object.defaultRadius * 1000

        let latLng = parseFloat(latitude) + ',' + parseFloat(longitude);
        placesSearch.helper.setQueryParameter('aroundLatLng', latLng);
        placesSearch.helper.setQueryParameter('aroundRadius', radiusInMeter).search();


        placesLocationsSearch.setQuery( __('Near', 'vn') );
        modalPlacesLocationsSearch.setQuery( __('Near', 'vn') );
      }
    }
    else {
      placesLocationsSearch.setQuery( currentLocation );
      modalPlacesLocationsSearch.setQuery( currentLocation );

      let placesInfo = object.placesAlgoliaValues
      let currentPlaceInfos = placesInfo[currentLocation]

      placesSearch.helper.setQueryParameter('aroundLatLng', '');
      placesSearch.helper.setQueryParameter('insidePolygon', '');

      placesSearch.helper.setQueryParameter(currentPlaceInfos.algolia_query, currentPlaceInfos.algolia_value).search();
      var radiusInMeter = object.defaultRadius * 1000

      placesSearch.helper.setQueryParameter('aroundRadius', radiusInMeter).search();
    }
  }

  $('.js-reset-location').on( 'click', function () {
    placesLocationsSearch.setQuery( '' );
    modalPlacesLocationsSearch.setQuery( '' );
  })
}


export { placesSearch }